export const isValidLinkedIn = (url: string): boolean => {
  if (!url) return false;
  let normalized = url.trim().replace(/\s+/g, "");
  while (normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }

  if (!/^https?:\/\//i.test(normalized)) {
    normalized = "https://" + normalized;
  }

  const regex = /^https?:\/\/(?:www\.)?linkedin\.com\/(?:in|company)\/[a-z0-9._-]{1,100}$/i;
  if (!regex.test(normalized)) return false;
  if (/error|404/i.test(normalized)) return false;

  return true;
};

export const normalizeLinkedIn = (url: string): string => {
  if (!url) return "";
  return url.trim().replace(/\s+/g, "");
};